export default {
    shallowCopyArrayObjects: function(arrayOfObjects) {
        var newArray = [];
        _.each(arrayOfObjects, function(object) {
            var newObject = {};
            for (var property in object) {
                newObject[property] = object[property];
            }
            newArray.push(newObject);
        });
        return newArray;
    }
};
